import React from "react";

/**
 * Original line illustrations for the four engagement steps.
 *
 * Drawn in the brand blue (#0640DC) with a pale tint for secondary strokes so
 * they sit in the same visual language as the rest of the site. Inline SVG:
 * no image files, no licensing questions, sharp at any size.
 */

const INK = "#0640DC";
const TINT = "#9DB6F7";
const FILL = "#E8EDFB";

const frame = {
  width: "100%",
  height: "100%",
  display: "block",
};

function Understand() {
  return (
    <svg viewBox="0 0 160 120" style={frame} role="img" aria-label="Mapping the client's estate">
      {/* the estate being surveyed */}
      <g stroke={TINT} strokeWidth="1.6" fill="none">
        <path d="M22 84h116" />
        <rect x="34" y="60" width="22" height="24" fill={FILL} />
        <rect x="66" y="48" width="26" height="36" fill={FILL} />
        <rect x="102" y="66" width="22" height="18" fill={FILL} />
      </g>
      {/* discovery lens sweeping across it */}
      <g stroke={INK} strokeWidth="2.4" fill="none" strokeLinecap="round">
        <circle cx="79" cy="52" r="23" />
        <path d="M96 69l16 16" />
      </g>
      <g stroke={INK} strokeWidth="1.8" fill="none" strokeLinecap="round">
        <path d="M70 54l7 7 13-16" />
      </g>
    </svg>
  );
}

function Tailor() {
  return (
    <svg viewBox="0 0 160 120" style={frame} role="img" aria-label="A solution shaped to fit">
      {/* the blueprint grid */}
      <g stroke={TINT} strokeWidth="1.2">
        <path d="M30 30h100M30 54h100M30 78h100M54 22v76M82 22v76M110 22v76" />
      </g>
      <rect x="30" y="22" width="100" height="76" stroke={TINT} strokeWidth="1.6" fill="none" />
      {/* the piece cut to fit it */}
      <path
        d="M54 78V54h28V30h28v48z"
        fill={FILL}
        stroke={INK}
        strokeWidth="2.4"
        strokeLinejoin="round"
      />
      <circle cx="110" cy="30" r="4.5" fill={INK} />
    </svg>
  );
}

function Implement() {
  return (
    <svg viewBox="0 0 160 120" style={frame} role="img" aria-label="Delivery and day-two support">
      {/* the rollout path */}
      <g stroke={TINT} strokeWidth="1.6" fill="none" strokeLinecap="round">
        <path d="M26 84h108" strokeDasharray="4 6" />
      </g>
      <g stroke={INK} strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="34" cy="84" r="6" fill={FILL} />
        <circle cx="80" cy="84" r="6" fill={FILL} />
        <circle cx="126" cy="84" r="6" fill={FILL} />
        {/* the system going live above it */}
        <rect x="56" y="26" width="48" height="34" rx="3" fill={FILL} />
        <path d="M80 60v18M66 40h28M66 48h18" />
      </g>
      <circle cx="126" cy="84" r="11" stroke={INK} strokeWidth="1.6" fill="none" opacity=".5" />
    </svg>
  );
}

function Improve() {
  return (
    <svg viewBox="0 0 160 120" style={frame} role="img" aria-label="Reviewed on a regular cycle">
      {/* the review loop */}
      <g stroke={INK} strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path d="M112 46a34 34 0 1 0 6 24" />
        <path d="M112 26v20h-20" />
      </g>
      {/* the trend it produces */}
      <g stroke={TINT} strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path d="M56 78l14-12 12 9 18-20" />
      </g>
      <circle cx="100" cy="55" r="4" fill={INK} />
    </svg>
  );
}

const ART = {
  "Understanding Client Needs": Understand,
  "Tailored Solutions": Tailor,
  "Implementation & Support": Implement,
  "Continuous Improvements": Improve,
};

function StepArt({ name }) {
  const Art = ART[name];
  return <span className="stepart">{Art ? <Art /> : null}</span>;
}

export default StepArt;
